import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { dashboardService } from '../../services/dashboardService';

interface Props { 
  year?: string; 
  month?: string;
}

export const ClientesCards: React.FC<Props> = ({ year, month }) => {
  const { user, isGrupo, isEmpresa } = useAuth();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    const load = async () => {
      if (!user) return;
      setLoading(true);
      try {
        const params: any = {};
        if (year) params.year = Number(year);
        if (month) params.month = Number(month);
        
        let res;
        if (isGrupo && user.grupoId) {
          // Para grupo, usar o endpoint de grupo que consolida dados de clientes
          res = await dashboardService.grupoOverview(user.grupoId, params);
        } else if (isEmpresa && user.empresaId) {
          res = await dashboardService.clientesOverview(user.empresaId, params);
        } else {
          throw new Error('Usuário não tem empresa ou grupo associado');
        }
        
        const payload = res?.data ?? res;
        setData(payload);
      } catch (err) {
        console.error('Erro ao carregar dashboard clientes:', err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    if (user && (isEmpresa || isGrupo)) load();
  }, [user, isGrupo, isEmpresa, month, year]);

  const fmtPercentage = (v: any) => {
    if (v === undefined || v === null) return '—';
    if (typeof v === 'number') return `${v.toFixed(1)}%`;
    return String(v);
  };

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#E0F7FA', color: '#006064' }}>
        <h3 className="text-xs font-semibold">Total de Clientes</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : data?.totalClientes ?? '—'}</p>
      </div>
      
      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#F1F8E9', color: '#33691E' }}>
        <h3 className="text-xs font-semibold">Novos no Período</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : data?.novosClientesPeriodo ?? '—'}</p>
      </div>

      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#FEF3E2', color: '#8B6914' }}>
        <h3 className="text-xs font-semibold">Crescimento %</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : fmtPercentage(data?.crescimentoPercentual)}</p>
      </div>

      <div className="p-3 rounded shadow h-24 flex flex-col justify-between" style={{ backgroundColor: '#FCE4EC', color: '#880E4F' }}>
        <h3 className="text-xs font-semibold">Renovações Próximas</h3>
        <p className="text-sm font-bold">{loading ? 'Carregando...' : data?.clientesRenovacaoProxima?.length ?? '—'}</p>
      </div>
    </div>
  );
};

export default ClientesCards;